import axios from 'axios';

export const getFacilityFeesApi = async (customerId) => {
  const response = await axios.get(
    `/admin/deal/customer/${customerId}/facility-fees`
  );
  return response.data;
};

export const createFacilityFeeApi = async (customerId, { dueDate, amount, comment }) => {
  const response = await axios.post(
    `/admin/deal/customer/${customerId}/facility-fee`,
    { dueDate, amount, comment }
  );
  return response.data;
};

export const deleteFacilityFeeApi = async (customerId, feeId) => {
  await axios.delete(`/admin/deal/customer/${customerId}/facility-fee/${feeId}`);
};

export const updateFacilityFeeApi = async (customerId, feeId, { dueDate, amount, status, comment, transferDate }) => {
  const response = await axios.put(
    `/admin/deal/customer/${customerId}/facility-fee/${feeId}`,
    { dueDate, amount, status, comment, transferDate }
  );
  return response.data;
};
